export default () => {
    const header = document.querySelector('[data-header]');
    const hamburger = document.querySelector('[data-hamburger]');

    hamburger.addEventListener('click', (e) => {
        e.preventDefault();
        if (hamburger.classList.contains('active')) {
            header.classList.remove('active');
            hamburger.classList.remove('active');
        } else {
            header.classList.add('active');
            hamburger.classList.add('active');
        }
    });

}
